import { initCarto } from './dossier-carto.js';
import {
  clampLines,
  limitListElements,
  getShowAllElement,
  waitForImageLoaded,
  avoidUpscalingImage,
  checkImageInError,
} from '../utils/utils.js';
import { initDossiersCarousel } from '../dossiers-carousel/dossiers-carousel.js';
import { Carto } from '../common/carte/carte-config.js';
import { manageButton } from '../selection/utils.js';

const CLAMPLINE_CONFIGURATIONS = [
  {
    selector: '.dossier-designation',
    listElementsLimit: 2,
    maxLines: 1,
  },
  {
    selector: '.dossier-localisation',
    listElementsLimit: 2,
    maxLines: 1,
  },
];

export const init = () => {
  const carousel = document.querySelector('.dossier .dossiers-carousel');
  if (carousel) {
    initDossiersCarousel();
  }

  initGeoref();

  // La hauteur de la carto ne s'initialise pas correctement sous Firefox :
  // La taille du container de la carto n'est pas correcte au moment de l'initialisation
  // (possiblement parce que l'image n'est pas encore chargée)
  // Attendons le chargement de l'image pour initialiser la carto
  const mainImageElement = document.querySelector('.dossier-illustration img');
  const dossierContainer = document.querySelector('.dossier.preview');
  if (mainImageElement) {
    const manageCarto = () => {
      const { updateSize: updateCartoSize } = initCarto();

      function updateCartilluSize() {
        // On s'assure que le bloc de texte en-dessous a la même taille que l'image
        // On modifie les règles de gestion dela grille CSS au lieu de modifier directement la taille
        // du bloc du texte en dessous de l'image pour ne pas casser l'affichage en mode mobile
        const width = [
          ...document.querySelectorAll(
            '.dossier-illustration img, .dossier-illustration .image-indispo',
          ),
        ]
          .map((element) => element.offsetWidth)
          .reduce((size1, size2) => Math.max(size1, size2), 0);
        dossierContainer.style.gridTemplateColumns = `fit-content(${width}px) auto`;
        updateCartoSize();
      }

      checkImageInError(mainImageElement, '.image-container');

      updateCartilluSize();

      avoidUpscalingImage(mainImageElement, () => updateCartilluSize());
    };
    waitForImageLoaded(mainImageElement, manageCarto, manageCarto);
  } else {
    initCarto();
  }

  const selectionButton = document.querySelector(
    '.search-results-preview [data-action="selection:add"]',
  );
  if (selectionButton) {
    manageButton(selectionButton);
  }

  CLAMPLINE_CONFIGURATIONS.forEach((configuration) => {
    document
      .querySelectorAll(`${configuration.selector} > ul.clampLines`)
      .forEach((clampedContainer) => {
        // La fonction clampLines ne permet pas de gérer directement une grille CSS
        // il est donc nécessaire de contourner cette difficulté en limitant d'abord le nombre d'éléments de la liste
        // puis en limitant la taille du texte de chaque élément de la liste

        // On partage le même bouton showAll entre la partie liste et la partie texte
        const showAllElement = getShowAllElement(clampedContainer);
        limitListElements(clampedContainer, configuration.listElementsLimit);

        // La fonction clampLines ne fonctionne pas sur l'ensemble du li à cause de la différence entre
        // l'affichage du titre et de la valeur.
        clampedContainer
          .querySelectorAll('li .value')
          .forEach((valueElement, index) => {
            if (index >= configuration.listElementsLimit) {
              return;
            }

            // Si la valeur est elle-même une liste, clampLines ne peut pas fonctionner directement
            // On doit d'abord limiter le nombre de <li> affichés à 1 puis enfin utiliser clampLines pour limiter la taille du premier <li>
            if (valueElement.matches('ul')) {
              limitListElements(valueElement, 1, showAllElement);

              valueElement
                .querySelectorAll('li')
                .forEach((subValueElement) =>
                  clampLines(
                    subValueElement,
                    configuration.maxLines,
                    false,
                    showAllElement,
                  ),
                );
            } else {
              clampLines(
                valueElement,
                configuration.maxLines,
                false,
                showAllElement,
              );
            }
          });
      });
  });
};

function initGeoref() {
  const jsonElement = document.querySelector('#dossier-georef-json');
  if (!jsonElement) {
    return;
  }

  Carto.dossierGeoref = JSON.parse(jsonElement.innerText);
}
